// ── Social Links ──────────────────────────────────────────────────────────────

export interface SocialLink {
  _id: string;
  title: string;
  url: string;
  icon: string;
  hoverIcon?: string;
  backgroundColor?: string;
  iconColor?: string;
  hoverIconColor?: string;
  hoverBackgroundColor?: string;
  ariaLabel: string;
  order: number;
}

export const socialLinks: SocialLink[] = [
  { _id: 'social-github',   title: 'GitHub',   url: 'https://github.com/Ellisvelandia',           icon: 'mdi:github',   ariaLabel: 'GitHub profile',   order: 1 },
  { _id: 'social-linkedin', title: 'LinkedIn', url: 'https://www.linkedin.com/in/ellisvelandia/', icon: 'mdi:linkedin', ariaLabel: 'LinkedIn profile', order: 2 },
  { _id: 'social-email',    title: 'Email',    url: 'mailto:dev@ellisvelandia.com',               icon: 'mdi:email',    ariaLabel: 'Email contact',    order: 3 },
  { _id: 'social-whatsapp', title: 'WhatsApp', url: 'https://wa.me/573125668800',                 icon: 'mdi:whatsapp', ariaLabel: 'WhatsApp contact', order: 4 },
  { _id: 'social-facebook', title: 'Facebook', url: 'https://www.facebook.com/ellis.velandia/',   icon: 'mdi:facebook', ariaLabel: 'Facebook profile', order: 5 },
];

// ── Helper functions ───────────────────────────────────────────────────────────

export async function getSocialLinks(): Promise<SocialLink[]> {
  return [...socialLinks].sort((a, b) => a.order - b.order);
}

